import { AsyncRequest } from 'angieslist-app-platform';

export default {
  ...AsyncRequest.createActionKeys('GET_NEW_ACTIVITY'),
  ...AsyncRequest.createActionKeys('GET_SERVICE_PROVIDERS'),
  ...AsyncRequest.createActionKeys('GET_ALL_SERVICE_PROVIDER_UNREAD_COUNTS'),
};



// WEBPACK FOOTER //
// ./src/app/common/businessList/businessListActionKeys.js